import React, { useState } from 'react'
import Checkbox from "../input-v2/Checkbox"

const MultiSelect = ({ field, isDark, onValueChange }) => {

  const [selectedValues, setSelectedValues] = React.useState([])

  return Array.isArray(field.dropdown_options) &&
    field.dropdown_options.length > 0 &&
    field.dropdown_options.map((item) => {

      const [checked, setChecked] = useState(false)

      const handleChange = (id, obj) => {
        let values = []
        !selectedValues.includes(item.value) ?
          values = [...selectedValues, item.value]
          :
          values = selectedValues.filter(val => val !== item.value)


        setSelectedValues(values)

        obj.value = values.join(',')

        setChecked(!checked)

        onValueChange(id, obj)
      }

      return (
        <Checkbox
          id={field.id}
          isDark={isDark}
          key={item.value}
          name={item.label}
          label={item.label}
          value={checked}
          checked={checked}
          onChange={handleChange}
        />
      )
    })
}

export default MultiSelect